import React from 'react';
import './styles.css';
import { ImageAsset } from 'res';

/**
 * @function CheckView
 * @return {React.Component}
 * @exported true
 * @description description
 */

export default function CheckView(props){
  const checkSide = props.checkSide ?? "CheckFront";

  return(
    <div className="check-view-container flex-container flex-horizontal flex-height all-center">
      <ImageAsset id={checkSide} className="check-image" />
    </div>
  );
}